import { defineStore } from 'pinia';
import LeadIntentsAPI from 'dashboard/api/leadIntents';

export const useLeadIntentsStore = defineStore('leadIntents', {
  state: () => ({
    list: [],
    loading: false,
    saving: false,
  }),
  actions: {
    async fetch() {
      this.loading = true;
      try {
        // ApiClient expõe get() (índice), não list(). O index retorna um array
        // puro (json.array!); fallback defensivo para { lead_intents: [...] }.
        const { data } = await LeadIntentsAPI.get();
        this.list = Array.isArray(data) ? data : data?.lead_intents || [];
      } finally {
        this.loading = false;
      }
    },
    // Alias semântico - mesma assinatura usada pelas demais stores de settings.
    async fetchAll() {
      return this.fetch();
    },
    async create(payload) {
      this.saving = true;
      try {
        const { data } = await LeadIntentsAPI.create({ lead_intent: payload });
        this.list = [...this.list, data].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        return data;
      } finally {
        this.saving = false;
      }
    },
    async update(id, payload) {
      this.saving = true;
      try {
        const { data } = await LeadIntentsAPI.update(id, {
          lead_intent: payload,
        });
        this.list = this.list.map(i => (i.id === id ? data : i));
        return data;
      } finally {
        this.saving = false;
      }
    },
    async destroy(id) {
      await LeadIntentsAPI.delete(id);
      this.list = this.list.filter(i => i.id !== id);
    },
  },
});
